<script lang="ts">
    import { mute, hold, answer, hangup } from './domain/call/telephony.actions';
    import { getBusinessWidgetConfig, getWidgetConfig } from './domain/session/receivers.actions'
    import { QueryClientProvider } from '@sveltestack/svelte-query'
    import { configureCss, initSentry, initOpenReplay, parseMobile } from './services/utils'
    import type { WidgetState } from './types/state'
    import Routes from './routes/index.svelte'
    import sessionStore from './store/session'
    import widgetStore from './store/widget'
    import Tailwind from './Tailwind.svelte'
    import UseHook from './services/hooks'
    import "toastify-js/src/toastify.css"
    import toast from './services/toast'
    import authState from './store/auth'
    import callStore from './store/call';
    import pubsub from 'sweet-pubsub'
    import { onMount } from 'svelte'
    import Modal from './common/Modal.svelte';
    import TakeNote from './screens/Feedback/TakeNote.svelte';
    import { jwtDecode } from "jwt-decode";
    import { getBusinesses } from './domain/session/profile.action';

    let isHookCalled: boolean = false;

    let queueSize: number = 0;

    const QUEUE_WAITING_TIME = 5;
    let countDownToCall = QUEUE_WAITING_TIME;
    let countDownToCallInterval = null;


    onMount(async () => {
        // authState.setPubKey("pk_34XsEi033ocVbA5Zm0X9YnvlSaqDg")
        window.addEventListener('message', async function(event) {
            const { data } = event
            
            const { 
                auth, 
                maximized, 
                phone, 
                control, 
                ...hooks 
            } = data;

            let business_id = null

            if ( auth ) {
                // authState.setPubKey(auth);
                const [token, mode = "prod"] = auth.split(":")
                authState.setAccessToken(token);
                authState.setMode(mode)
                const { business_id: __business_id__ }: {business_id: number, user_id: number} = jwtDecode(token);
                business_id = __business_id__
                const { user, profiles = [] } = await getBusinesses();

                authState.setUser(user);
                sessionStore.setProfiles(profiles)

                const profile = profiles.find( p => p.business?.id === __business_id__) || {}

                sessionStore.setProfile(profile);
                sessionStore.setReceivers([])
            }

            const existingConfig: WidgetState = $widgetStore;
            
            if ( !existingConfig.widget_type && auth && business_id ) {
                try {
                    // const config = await getWidgetConfig();
                    const config = await getBusinessWidgetConfig(business_id);
                    widgetStore.set(config)
                    configureCss(config)
                    window.parent.postMessage(config, "*")
                } catch (_) {}
            }

            if (hooks && !isHookCalled) {
                const cti = UseHook.useCti(hooks);
                initSentry($sessionStore.user);
                initOpenReplay($sessionStore.user)
                isHookCalled = true
            }

            if ( control ) {
                switch (control) {
                    case "mute":
                        mute(true)
                        break;
                    case "unmute":
                        mute(false)
                        break;
                    case "hold":
                        hold(true)
                        break;
                    case "unhold":
                        hold(false)
                        break;  
                    case "answer":
                        answer()
                        break;
                    case "hangup":
                        hangup()
                        break;
                    case "callInfo":
                        const { name, initials, email, mobile } = hooks
                        const payload: any = {
                            peerName: name,
                            peerInitials: initials
                        }
                        if ( mobile ) {
                            payload.peer = mobile
                        }
                        callStore.update(payload)
                        break;
                    default:
                        throw new Error("Unknown control");
                }
            }

            if ( phone ) {
                pubsub.emit('initiate_call', phone);
            }

        });

        setTimeout(async () => {
            if (!isHookCalled) {
                new UseHook()
                initSentry($sessionStore.user)
                initOpenReplay($sessionStore.user)
                isHookCalled = true
            }
        }, 1500);
    });

    $: {
        if ($sessionStore.queue?.pending?.length !== queueSize && $sessionStore.queue?.pending?.length > 0) {
            const nextContactToCall = $sessionStore.queue?.pending[0];
            if(nextContactToCall && countDownToCall === QUEUE_WAITING_TIME && countDownToCallInterval) {
                toast.warn(`Calling ${nextContactToCall.name} on ${nextContactToCall.number} in ${countDownToCall}sec`)
            }

            if (!countDownToCallInterval) {
                countDownToCallInterval = setInterval(function() {
                    countDownToCall--;
                    if (countDownToCall <= 0) {
                        clearInterval(countDownToCallInterval)
                        countDownToCall = QUEUE_WAITING_TIME;
                        pubsub.emit('initiate_call', nextContactToCall.number);
                    }
                }, 1000)
            }
        }
    }

    const handleCompletedCall = async (peer: string) => {
        const { pending = [], completed = [] } = $sessionStore.queue || {}
        const completedCallContact = pending.find(contact => parseMobile(contact.number) === parseMobile(peer))
        if (completedCallContact) {
            const __pending__ = pending.filter(contact => contact.number !== completedCallContact.number)
            completed.push(completedCallContact)
            sessionStore.setQueue({
                pending: __pending__,
                completed
            });
            queueSize = __pending__.length
        }
    }

    pubsub.on('call_ended', async ({peer}) => {
        await handleCompletedCall(peer)
    })

</script>
<Tailwind />
<QueryClientProvider>
    <main class="conatainer">
        <Modal
            open={$callStore.takeNote} 
            close_on_escape={true} 
            close_on_background_click={true} 
            on:close={() => callStore.update({takeNote: false})}
        >
            <TakeNote />
        </Modal>
        <Routes />
        <audio id="remoteAudio" />
    </main>
</QueryClientProvider>

<style>
    /* .primary-text-color {
        color: var(--primary-text-color)
    }
    .secondary-text-color {
        color: var(--secondary-text-color)
    }
    .primary-bg-color {
        background-color: var(--primary-bg-color)
    }
    .secondary-bg-color {
        background-color: var(--secondary-bg-color)
    } */
</style>
